var map = {
	"./001.jpeg": 8448,
	"./002.jpeg": 6189,
	"./003.jpeg": 2226,
	"./004.jpeg": 9624,
	"./005.jpeg": 2482,
	"./006.jpeg": 7700,
	"./007.jpeg": 642,
	"./008.jpeg": 4816,
	"./01.jpg": 2915,
	"./02.png": 6669,
	"./03.jpg": 3895,
	"./1.jpeg": 9462,
	"./10.jpeg": 3086,
	"./11.jpeg": 8495,
	"./12.jpeg": 1542,
	"./13.jpeg": 6350,
	"./14.jpeg": 7117,
	"./15.jpeg": 510,
	"./16.jpeg": 2304,
	"./17.jpeg": 4921,
	"./18.jpeg": 5226,
	"./19.jpeg": 9092,
	"./2.jpeg": 9496,
	"./20.jpeg": 9608,
	"./21.jpeg": 3959,
	"./22.jpeg": 6637,
	"./23.jpeg": 9529,
	"./2993773_git_social media_icon.png": 7535,
	"./3.jpeg": 9244,
	"./4.jpeg": 4524,
	"./5.jpeg": 5089,
	"./6.jpeg": 6567,
	"./7.jpeg": 2591,
	"./8.jpeg": 2411,
	"./9.jpeg": 7263,
	"./Bootstrap.png": 6569,
	"./CSS3.png": 8314,
	"./Git.png": 8441,
	"./GitHub.png": 5910,
	"./HTML.png": 279,
	"./JavaScript.png": 8727,
	"./NextJs.png": 3919,
	"./ReactJs.png": 822,
	"./Sass.png": 9106,
	"./ballon.png": 2041,
	"./email2.png": 2153,
	"./freelancer.jpg": 7712,
	"./freelancer11.jpg": 8037,
	"./freelancer22.jpg": 2617,
	"./graybalon.png": 786,
	"./main2.png": 2510,
	"./messenger2.png": 3998,
	"./ossama_magdy_cv.pdf": 1712,
	"./phot.jpg": 7742,
	"./plus-orange.png": 5685,
	"./square-dots-orange.png": 4741,
	"./squareimg.png": 7954,
	"./twobalone.png": 8772,
	"./whatsapp2.png": 6508,
	"./zigzag.png": 2083
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1327;